import { getI18n } from 'react-i18next';

import Config from '../../../../Config';
import Logger from '../../../../lib/Logger';
import Events from '../../../../lib/EventEmitter';

import CognitoFormsAdminScreen from './containers/CognitoFormsAdminScreenContainer';

const register = () => {
  Logger.log('debug', `cognitoFormsAdmin.register()`);

  if (Config.getIn(['MODULE_TOGGLES', 'cognitoFormsAdmin', 'routes'])) {
    Events.dispatch('ADD_ADMIN_ROUTES', {
      CognitoFormsAdminScreen: [
        'PrivateRoute',
        '/admin/cognito-forms/:page(\\d+)?',
        true,
        CognitoFormsAdminScreen,
        getI18n().t('cognito_forms_admin_route_list'),
      ],
    });
  }
};

export default register;

Logger.log('silly', `cognitoFormsAdmin.register() loaded.`);
